import { api } from '../client/client.js';
import { formatDate } from '../format/format.js';

function mapLink(l) {
  return {
    id: l.id,
    slug: l.slug,
    note: l.note,
    url: l.url,
    registrations: Number(l.registrations) || 0,
    payingUsers: Number(l.paying_users) || 0,
    createdAtLabel: formatDate(l.created_at),
  };
}

export function listRefLinks() {
  return api.get('/reflinks').then((data) => ({
    botUsername: data.bot_username || null,
    links: (data.links || []).map(mapLink),
    sources: (data.sources || []).map((s) => ({
      source: s.source,
      url: s.url,
      registrations: Number(s.registrations) || 0,
      payingUsers: Number(s.paying_users) || 0,
      lastRegisteredLabel: formatDate(s.last_registered_at),
    })),
  }));
}

export function createRefLink({ slug, note }) {
  return api.post('/reflinks', { slug, note }).then(mapLink);
}

export function deleteRefLink(id) {
  return api.delete(`/reflinks/${id}`);
}
